export default __webpack_public_path__ + "static/media/loading.5a3279d8.gif";